import { UserUtils } from '@dndbeyond/authentication-lib-js';

import ApiUtils from './ApiUtils';

const getUserToken = () =>
    ApiUtils.getDecodedShortTermToken().then((token) => {
        return token;
    });
const getUser = () =>
    getUserToken().then((token) => ({ ...UserUtils.jwtToUser(token), displayName: token.displayName }));

const getUserDisplayName = () =>
    getUser().then((user) => {
        return user.displayName;
    });
const getUserId = () => getUser().then(UserUtils.getId);
const getSubscriptionTier = () => getUser().then(UserUtils.getSubscriptionTier);

export default {
    getUserToken,
    getUser,
    getUserId,
    getSubscriptionTier,
    getUserDisplayName,
};
